/**
 * SearchInput — search icon + input field.
 *
 * Extracts the repeated search pattern from admin list pages.
 */

import { forwardRef, type InputHTMLAttributes } from 'react'
import { clsx } from 'clsx'
import { Search } from 'lucide-react'

export interface SearchInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Additional classes for the wrapper div. */
  wrapperClassName?: string
}

/** Search input with icon. */
export const SearchInput = forwardRef<HTMLInputElement, SearchInputProps>(
  ({ wrapperClassName, className, ...props }, ref) => {
    return (
      <div className={clsx('relative', wrapperClassName)}>
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-content-tertiary pointer-events-none" />
        <input
          ref={ref}
          type="text"
          className={clsx(
            'w-full pl-10 pr-4 py-2.5 border border-border rounded-lg transition-all',
            'bg-surface-input text-content text-sm',
            'focus:outline-none focus:border-accent focus:ring-2 focus:ring-accent/20',
            'placeholder:text-content-tertiary',
            className,
          )}
          {...props}
        />
      </div>
    )
  },
)

SearchInput.displayName = 'SearchInput'
